import { render, staticRenderFns } from "./CollaborativeListCreation.vue?vue&type=template&id=41846ff8&scoped=true"
import script from "./CollaborativeListCreation.vue?vue&type=script&lang=js"
export * from "./CollaborativeListCreation.vue?vue&type=script&lang=js"
import style0 from "./CollaborativeListCreation.vue?vue&type=style&index=0&id=41846ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41846ff8",
  null
  
)

export default component.exports